import React from 'react';
import { SpeedMeter as SpeedMeterView } from 'components/views/molecules/SpeedMeter';
import { useVehicleStatus } from 'services/useVehicleStatus';
import { Project } from 'core/models/project';
import { Vehicle } from 'core/models/vehicle';

export type SpeedMeterProps = {
    className?: string;
    vehicleId: Vehicle.Id;
    projectId: Project.Id;
}

export const SpeedMeter = (props: SpeedMeterProps) => {
    const status = useVehicleStatus(props.vehicleId, props.projectId);

    return (
        <SpeedMeterView className={props.className} values={status} />
    );
};
